import "./AccessDenied.css";
import { FaLock, FaArrowLeft, FaHome } from "react-icons/fa";

export default function AccessDenied() {
  return (
    <div className="access-denied-page">

      <div className="bg-shape bg1"></div>
      <div className="bg-shape bg2"></div>
      <div className="bg-shape bg3"></div>

      <div className="access-card">

        <div className="shield-wrapper">

          <div className="shield">

            <div className="ring"></div>

            <div className="lock-circle">
              <FaLock />
            </div>

          </div>

        </div>

        <div className="error-code">
          403
        </div>

        <h1 style={{color: '#667085',fontWeight: '700', marginBottom: '18px'}}>
          Access Denied
        </h1>

        <p style={{color: '#667085', lineHeight: '1.8', marginBottom: '35px'}}>
          It looks like you don't have permission to access this page.
          If you believe this is a mistake, please contact an administrator
          or return to a page you have access to.
        </p>

        <div className="button-group">

          <button
            className="btn btn-light custom-btn"
            onClick={() => window.history.back()}
          >
            <FaArrowLeft />
            Back
          </button>

          <button
            className="btn custom-btn home-btn"
            onClick={() => (window.location.href = "/")}
          >
            <FaHome />
            Home
          </button>

        </div>

      </div>

    </div>
  );
}